import React from "react";
import styles from "./CustomButton.module.scss";
import PlusIcon from "../../assets/icons/PlusIcon";
const CustomButton = ({
  onClick,
  blue = false,
  children,
  plus,
  width = "100%",
  height = "49px",
  isLoading,
}) => {
  return (
    <button
      className={blue === true ? styles.blue : styles.transparent}
      onClick={onClick}
      style={{ width: `${width}`, height: `${height}` }}
    >
      {isLoading ? (
        <span class="loader"></span>
      ) : (
        <>
          {plus && <PlusIcon />}
          {children}
        </>
      )}
    </button>
  );
};

export default CustomButton;
